import { FRONTIFY_URL } from '@shared/utils';

const IMAGE_BY_STEP: Record<string, string> = {
  'steps.step_1': `${FRONTIFY_URL}Ze8Hfg33ghhzDMw7ecb9.webp`,
  'steps.step_2': `${FRONTIFY_URL}gNFZoqKxK1Q1VYB6GrEh.webp`,
  'steps.step_3': `${FRONTIFY_URL}EFP9FiXTpNQx8gaiiB2C.webp`,
  'steps.step_4': `${FRONTIFY_URL}3X2QSZABKsh9ikEJaxJH.webp`,
  'steps.step_5': `${FRONTIFY_URL}b8iUKTiei6gdfBfiFuRS.webp`,
};

const getEducationalStepImage = (stepKey: string): string => {
  const image = IMAGE_BY_STEP[stepKey];
  return image !== undefined ? image : IMAGE_BY_STEP['steps.step_1']!;
};

export { getEducationalStepImage };
